import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import HabitHeroRewardImg from '../../../images/rewards/HabitHero.svg';

export const HabitHero = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2} style={{ marginBottom: "2rem", fontWeight: storyData.data.hasHabitHeroStreak ? "450" : "500" }}>
                {storyData.data.heading}
            </h1>
            <div className={styles.habitHeroReward}>
                <img src={HabitHeroRewardImg} style={{ height: "100%", width: 'auto' }}></img>
            </div>
            {storyData.data.message &&
                <p style={{ maxWidth: "18.5rem" }} className={styles.habitHeroStreakText}>
                    {storyData.data.message}
                </p>
            }
        </StoryWrapper>
    )
}